import React from 'react';
import { Box as Wrapper, Text } from '@tonic-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { Modal } from '../../components/modal';
import { ExternalLink } from '../../components/external-link';

type SupportUnauthenticatedModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SupportUnauthenticatedModal = ({
  isOpen,
  onClose,
}: SupportUnauthenticatedModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      id="support"
      isOpen={isOpen}
      onClose={onClose}
      size="auto"
      header={
        <Text size="xl" lineHeight="xl">
          {t('support.supportModal.modalTitle')}
        </Text>
      }
      body={
        <Wrapper marginTop="3x" maxWidth="500px" paddingBottom="4x">
          <Text size="sm" fontWeight="normal" lineHeight="sm">
            <Trans i18nKey="support.supportModal.modalContact" marginBottom="15px" />
          </Text>
          <Text size="sm" fontWeight="normal" width="100%" lineHeight="sm" marginTop="15px">
            {t('support.supportModal.modalDescription')}
            <ExternalLink showIcon={false} href={t('support.supportModal.supportLink')}>
              <Text fontWeight="normal" width="100%" textDecoration="underline">
                {t('support.supportModal.supportLinkText')}
              </Text>
            </ExternalLink>
            .
          </Text>
        </Wrapper>
      }
    />
  );
};
SupportUnauthenticatedModal.displayName = 'SupportUnauthenticatedModal';

export default SupportUnauthenticatedModal;
